import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";
import {EVENT_NOTICE} from "@COMPONENTS/common/constants";

interface EventNotice {
	evCd: string;
	singleTypeCd: string;
	trTp: string;
	goodsCd: string;
	goodsTp: string;
	daySeq: number;
	shopCnt: number;
	inclInfo: string;
	notinclInfo: string;
	miscInfo: string;
	goodsInfo: string;
	vimeoUrl: string;
	shopInfo: string;
	poliInfo: string;
	cancelInfo: string;
	optInfo: string;
	refeInfo: string;
	essenInfo: string;
	passportInfo: string;
	foldAttaFileKey: string;
	stretAttaFileKey: string;
	meetingnoyn: string;
	meetingnm: string;
	meetingtm: string;
	meetingmanager: string;
	meetingtelno: string;
	meetingnote: string;
	keyInfoImageList: {
		evCd: string;
		kinfoDivi: string /** AR: 지역소개, MA: 지도, HT: 호텔리조트 */;
		pcAttaFilePath: string;
		moAttaFilePath: string;
	}[];
}

/** ```
 * 행사 공지사항
 *   `/pkg/event/{eventCode}/notice`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventNotice";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event/${evCd}/notice`;
};

/** ```
 * 행사 공지사항 SSR
 *   `/pkg/event/{eventCode}/notice`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const eventNoticeSSR = (evCd: string) =>
	useConfigureAxios(getPath(evCd), {
		method: "GET",
	});

/** ```
 * 행사 공지사항
 *   `/pkg/event/{eventCode}/notice`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventNotice = (evCd: string, options?: Partial<UseQueryOptions<Response<EventNotice>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		placeholderData: {body: EVENT_NOTICE},
		...options,
	});

export default useEventNotice;
export {getPath, eventNoticeSSR};
export type {EventNotice};
